import Spinner from "src/components/Spinner";

export const PageLoader = () => {
    return (
        <Spinner />
    );
};